import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { Project } from '../Project'
import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Task } from '../../task/Task'

@InputType()
export class CloneProjectTaskArgs extends ActionArgs {
  @Field(() => ID)
  projectId: string

  @Field(() => ID)
  sourceTaskId: string
}

@ObjectType()
@InputType('CloneProjectTaskResultInput')
export class CloneProjectTaskResult {
  @Field(() => Task)
  task: Task

  @Field(() => Project)
  project: Project
}

export interface ICloneProjectTask extends IAction<CloneProjectTaskResult, CloneProjectTaskArgs> {}
